<template>
  <div class="app-content--equal-padding px-7 px-md-16 py-8">
    <header class="mb-8">
      <v-card-title
        class="headline font-weight-bold mb-1 pa-0 letter-spacing-compact"
      >
        2. Select Amount
      </v-card-title>
    </header>
    <v-row class="mt-0">
      <v-col class="py-0 mb-5">
        <v-card flat class="px-0 py-0">
          <v-list
            flat
            elevation="0"
            tile
            dense
            max-height="400"
            class="overflow-auto border-none"
          >
            <v-list-item class="d-flex pa-0 body-1">
              <v-list-item-content class="pa-0">
                <v-list-item-title class="body-1 font-weight-bold">
                  Total balance
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="my-0 font-weight-bold">
                ${{ user.getBalance() }}
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-3 mb-5 px-0">
        <div id="projectSearch" class="position-relative">
          <ValidationProvider
            name="amount_percentage"
            rules="required|min_value:25|max_value:100"
            v-slot="{ errors }"
          >
            <v-slider
              height="20"
              tick-size="55"
              step="25"
              v-model.number="request.percentage"
              thumb-label="always"
              thumb-size="55"
              :error-messages="errors"
              track-color="#E9E9E9"
              class="mt-10 large-thumb"
            >
              <template v-slot:thumb-label>
                $ {{ getValueFromPercentage().currency(0) }}
              </template>
            </v-slider>
            <v-row class="justify-center">
              <v-chip
                small
                v-for="value in [25, 50, 75]"
                :key="value"
                :color="value === request.percentage ? 'primary' : 'white'"
                class="elevation-2 px-4 mx-5 body-2"
                @click="request.percentage = value"
              >
                {{ value }} %
              </v-chip>
            </v-row>
          </ValidationProvider>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PayoutRequest from '@request/PayoutRequest';
import { mapState } from 'vuex';

export default {
  name: 'SelectAmount',
  props: {
    request: {
      type: PayoutRequest,
      required: true,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapState('auth', {
      user: 'user',
    }),
  },
  watch: {
    'request.percentage': {
      async handler(value) {
        await this.$nextTick();
        if (value < 25) {
          this.request.percentage = 25;
        } else if (value > 100) {
          this.request.percentage = 100;
        }
      },
    },
  },
  methods: {
    getValueFromPercentage(
      percentage = this.request.percentage,
      total = this.user.getBalance()
    ) {
      return ((percentage / 100) * total).currency(2);
    },
  },
};
</script>

<style lang="scss" scoped></style>
